import interfaceAjax from '@/libs/InterfaceAjax';

export default {
    etypeList() {
        return interfaceAjax({
            url: '/admin/equipType/list',
        });
    },
    etypeAdd(data) {
        return interfaceAjax({
            url: '/admin/equipType/add',
            data
        });
    },
    etypeUpdate(data) {
        return interfaceAjax({
            url: '/admin/equipType/update',
            data
        });
    },
    etypeDelete(id) {
        return interfaceAjax({
            url: '/admin/equipType/delete',
            data:{id}
        });
    },
    placeList() {
        return interfaceAjax({
            url: '/admin/place/list',
            data:{id:null}
        });
    },
    placeAll(data) {
        return interfaceAjax({
            url: '/admin/place/all',
            data
        });
    },
    //-----车辆保险-----//
    insuranceList(params, plateNo) {
        return interfaceAjax({
            url: '/admin/insurance/list',
            params,
            data: {plateNo}
        });
    },
    insuranceAdd(data) {
        return interfaceAjax({
            url: '/admin/insurance/add',
            data
        });
    },
    insuranceDelete(id) {
        return interfaceAjax({
            url: '/admin/insurance/delete',
            data:{id}
        });
    },
    equipSearch(data) {
        return interfaceAjax({
            url: '/admin/equip/equipSearch',
            data:data
        });
    },
    //-----车辆档案-----//
    equipList(params, data) {
        var cdata = {...data}
        cdata.status && cdata.status==-10 && (cdata.status = null)
        return interfaceAjax({
            url: '/admin/equip/list',
            params,
            data:cdata
        });
    },
    equipAdd(data) {
        return interfaceAjax({
            url: '/admin/equip/add',
            data
        });
    },
    equipDelete(id) {
        return interfaceAjax({
            url: '/admin/equip/delete',
            data:{id}
        });
    },
    equipCheck(data) {
        return interfaceAjax({
            url: '/admin/equip/check',
            data
        });
    },
    equipUpdate(data) {
        return interfaceAjax({
            url: '/admin/equip/update',
            data
        });
    },
    uncheckNum() {
        return interfaceAjax({
            url: '/admin/equip/uncheckNum'
        });
    },

    terminalAdd(data){
        return interfaceAjax({
            url: '/admin/terminal/add',
            data
        });
    },
    terminalUpdate(data){
        return interfaceAjax({
            url: '/admin/terminal/update',
            data
        });
    },
    terminalDetail(id){
        return interfaceAjax({
            url: '/admin/terminal/detail',
            data:{id}
        });
    },

    reportList(params, data){
        return interfaceAjax({
            url: '/admin/report/list',
            params,
            data
        });
    },
    reportAdd(data){
        return interfaceAjax({
            url: '/admin/report/add',
            data
        });
    },
    updateScanPic(data){
        return interfaceAjax({
            url: '/admin/report/updateScanPic',
            data
        });
    },
    reportUpdateCheck(id, checkStatus, expireDate, checkSignPic, approveSignPic){
        return interfaceAjax({
            url: '/admin/report/updateCheck',
            data:{id, checkStatus, expireDate, checkSignPic, approveSignPic}
        });
    },
    reportUpdate(id, limitVal, highDis){
        return interfaceAjax({
            url: '/admin/report/updateReport',
            data:{id, limitVal, highDis}
        });
    },
    reportDelete(id){
        return interfaceAjax({
            url: '/admin/report/delete',
            data:{id}
        });
    },

    operatorList(params, data){
        return interfaceAjax({
            url: '/admin/operator/list',
            params,
            data
        });
    },
    operatorAdd(data){
        return interfaceAjax({
            url: '/admin/operator/add',
            data
        });
    },
    operatorDelete(id){
        return interfaceAjax({
            url: '/admin/operator/delete',
            data:{id}
        });
    },

    appointmentList(params, data){
        return interfaceAjax({
            url: '/admin/appointment/list',
            params,
            data
        });
    },
    appointmentDelete(id){
        return interfaceAjax({
            url: '/admin/appointment/delete',
            data:{id}
        });
    },

    violationList(params, data){
        return interfaceAjax({
            url: '/admin/violation/list',
            params,
            data
        });
    },
    violationDelete(id){
        return interfaceAjax({
            url: '/admin/violation/delete',
            data:{id}
        });
    },

    receiveAdd(data){
        return interfaceAjax({
            url: '/admin/receive/add',
            data
        });
    },

    syncCity(id) {
        return interfaceAjax({
            url: '/admin/equip/syncCity',
            data:{id}
        });
    },

    updateScanPicAndVideo(data){
        return interfaceAjax({
            url: '/admin/report/uploadVideo',
            data
        });
    },

    downloadCity(epNo) {
        return interfaceAjax({
            url: '/admin/equip/downloadCity',
            data:{epNo}
        });
    },

}
